import { DisplayAdProfileLeaderboardSlot } from '@xing-com/crate-ads-display-ads';
import {
  Ad as NativeAd,
  SiteSections,
  useAds,
} from '@xing-com/crate-ads-native-ads';
import { AdTypes } from '@xing-com/crate-common-graphql-types';
import { useExperiment } from '@xing-com/hub';

import * as Styles from './ad.styles';

export const Ad: React.FC = () => {
  const isAdTest = useExperiment('ABACUS-574') === 'B';

  const { ads, isCompleted, isSkipped } = useAds({
    adCount: 1,
    adTypes: [AdTypes.WebsiteAd],
    channel: 'profile_web_logged_out',
    isLoggedOut: true,
    skipQuery: !isAdTest,
  });

  if (isAdTest && !isSkipped && !isCompleted) {
    return null;
  }

  if (isAdTest && !isSkipped && ads.length > 0) {
    return (
      <Styles.NativeAdContainer>
        <NativeAd {...ads[0]} sectionId={SiteSections.Profile} isLoggedOut />
      </Styles.NativeAdContainer>
    );
  }

  return (
    <Styles.AdsContainer>
      <DisplayAdProfileLeaderboardSlot />
    </Styles.AdsContainer>
  );
};
